<template>
  <div class="d-none d-sm-block myDesktop  maxUsers ">
    <div
        class="col-12 col-sm-3 col-xl-2 px-sm-2 px-0 bg-darks  sticky-top d-flex flex-sm-column  flex-grow-1  pt-2 text-white "
        style="overflow: hidden;  position: fixed;">
      <div class="p-1  myTimer">
        <div id="timer">
          <div class="d-flex">
            <div class="p-1 flex-grow-1 bd-highlight" style="font-size: 15px"><span>مدت‌زمان</span></div>
            <button class="spinner-border btn btn-link" v-if="isLoaderVisible =='false'"></button>
            <div class="p-1 flex-grow-1" style="font-size: 15px; text-align: end;" v-else>
              {{ (errors !== '') ? errors : (timeoutHandle) ? timeoutHandle : '00:00' }} &nbsp;
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row justify-content: center">
        <div class="p-2">
          <img src="../../../assets/images/students.png" class="rounded-circle" height="80" width="80">
        </div>
      </div>
      <hr>
      <div class="p-1 "><span>نام‌کاربر</span>: {{ users.name_f }}</div>
      <hr>
      <div class="p-1 "><span>سطح‌آزمون</span> :
        {{
          (cate.level === 'preliminary') ? leve.preliminary : (cate.level === 'hard') ? leve.hard : leve.medium
        }}
      </div>
      <hr>
      <div class="p-1 ">
        <span> عنوان‌آزمون</span>: &nbsp <span style="color: white">{{ cate?.title }}</span>
      </div>
      <hr>
      <div class="p-1 "><span>زمان‌پاسخ دهی</span>: {{ cate?.date }} دقیقه</div>
      <div class="p-1 "><span>حدنصاب‌قبولی</span>: {{ (cate?.acceptance * cate?.count) / 100 }} پاسخ‌صحیح
      </div>
      <hr>
      <div class="p-1 text-center" v-if="cate.id">
        <btn_loading v-if="loading"></btn_loading>
        <button type="button" v-else @click="btn_end_time" class="btn  btn-dark w-100"
                title="با زدن این گزینه زمان  آزمون اتهام می رسد و پاسخ شما ثبت  میشود">ثبت‌پاسخ‌نامه
        </button>
      </div>
    </div>
  </div>
  <!--  show to sm-->
  <div class="d-block d-sm-none myMobileDiv bg-darks text-white w-100 " style="overflow: hidden;  position: fixed;">
    <div class="d-flex">
      <div class="p-1 w-50  text-white"><span>نام‌کاربر</span>:{{ users.name_f }}</div>
      <div class="p-1 w-50  text-white"><span>سطح‌آزمون</span>:
        {{
          (cate.level === 'reliminary') ? leve.preliminary : (cate.level === 'hard') ? leve.hard : leve.medium
        }}
      </div>
    </div>
    <div class=" d-flex">
      <div class="p-1 w-50  text-white"><span> حدنصاب‌قبولی </span>:{{ (cate?.acceptance * cate?.count) / 100 }}
        پاسخ
        صحیح
      </div>
      <div class="p-1 w-50 btn text-white"><span> تعدادسوالات‌ها</span>: &nbsp {{ cate?.count }}</div>
    </div>
    <div class=" d-flex">
      <div class="p-2 w-100">
        <span> عنوان‌آزمون</span>:{{ cate?.title }}
      </div>
    </div>
    <div class=" d-flex">
      <btn_loading v-if="loading"></btn_loading>

      <div class="p-1 w-50" v-else v-if="cate.id !==''">
        <button type="button" @click="btn_end_time"
                class="btn btn-success form-control "
                title="بازدن‌این‌گزینه‌زمان‌آزمون‌اتهام‌می رسد‌وپاسخ‌شماثبت‌میشود">ثبت پاسخ نامه
        </button>
      </div>
      <div class="p-1 w-100">
        <button type="button" class="btn btn-outline-danger  form-control" id="mytimer">
          <span style="float: right; color:white"> مدت‌زمان </span>:
          <span class="spinner-border btn btn-link" v-if="isLoaderVisible =='false'" style="float: left;"></span>
          <span style="color:white; float: left;" v-else>{{ timeoutHandle }} </span>
        </button>
      </div>
    </div>

  </div>
</template>
<script>
import config from "../../../../../config/config.json"
import {navbar} from "@/customer/mixins/navbar";
import axios from "axios";
import {useToast} from "vue-toastification";
import Btn_loading from "@/common/components/LoadingAzmoon.vue";

export default {
  components: {Btn_loading},
  mixins: [navbar],
  name: "navbar",
  mounted() {
    this.getDesignQuestion();
    if (window.location.pathname == "/home") {
      this.getDate();
      setInterval(() => {
        this.createTimers();
      }, 1003)
      setInterval(() => {
        this.isLoaderVisible = 'true';
      }, 2000)
    }
  },
  methods: {
    getDate() {
      let self = this;
      let cat_id = localStorage.getItem('cat_id')
      axios.get(`${config.BASE_URL}/customers/data/${cat_id}`)
          .then(function (response) {
            self.timeoutHandle = response.data.data;
          })
          .catch(function (errors) {
            if (errors.response.status === 404) {
              self.clear_localStoreg()
              return self.$router.push({path: `/results/${errors.response.data.messages}/404`});
            }
          });
    },
    getDesignQuestion() {
      let self = this;
      let cat_id = localStorage.getItem('cat_id')
      axios.get(config.BASE_URL + `/DesignQuestion/${cat_id}`)
          .then(function (response) {
            let res = response.data;
            if (res.status === 'true') {
              self.cate = res.data.cat;
              self.cat_id = res.data.cat.id
              self.users = res.data.users;
              self.lists = res.data.list
            }
          })
          .catch(function (errors) {
            if (errors.response.status === 404) {
              return self.$router.push({path: `/results/${errors.response.data.messages}/404`});
            }
          });

    },
    btn_end_time() {
      let self = this;
      if (self.endStatus === "false") {
        return false;
      }
      let extracted = self.extracted()
      self.check(self.lists.length, extracted.length);
    },
    check(countQuestion, countAnswers) {
      let self = this;
      const toast = useToast();
      let extracted = self.extracted()
      let count = Math.abs(countQuestion - countAnswers);
      let timer = self.timeoutHandle.split(':');
      if (timer[0] === "00" && timer[1] < 20) {
        self.sendData(extracted);
        return true;
      }
      if (count === countQuestion) {
        toast.error("برای شرکت در آزمون باید یک گزینه انتخاب کنید");
        return false;
      }
      if (count > 0) {
        self.$swal.fire({
          html: `<p class="text-center" >  شما از ${countQuestion} سوال، ${count} سوال را جواب نداده‌اید. آیا می‌خواهید آزمون به پایان برسد؟ </p>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#088704',
          cancelButtonColor: '#d33',
          allowOutsideClick: false,
          confirmButtonText: 'بله پایان  آزمون',
          cancelButtonText: 'خیر  آزمون را ادامه میدم'
        }).then((result) => {
          if (result.isConfirmed) {
            self.sendData(extracted);
            return true;
          }
        })
      } else {
        self.sendData(extracted);
      }
    },
    sendData(data) {
      let self = this;
      self.loading = true;
      const toast = useToast();
      let formData = new FormData();
      data.forEach(function (value) {
        formData.append('data[]', 'question_id=' + value?.question_id + 'answers_id=' + value?.answers_id)
      })
      formData.append('cat_id', self.cate.id)
      self.axios.post(self.url, formData).then(function (response) {
        self.loading = false;
        let res = response.data;
        if (res.status === 'true') {
          self.endStatus = false;
          self.clear_localStoreg()
          self.$router.push({path: `/results/${btoa(res.data)}/200`});
          return true
        }
      }).catch(function (errors) {
        self.loading = false;
        self.endStatus = false;
        if (errors.response.status === 422) {
          Object.values(errors.response.data.errors).forEach(function (val, key) {
            toast.error(val[0]);
          });
        }
        if (errors.response.status === 404 || errors.response.status === 500) {
          self.clear_localStoreg()
          return self.$router.push({path: `/results/${errors.response.data.messages}/404`});
        }
      });
    },
    extracted() {
      let self = this;
      let countNumbers = [];
      for (let [key, value] of Object.entries(localStorage)) {
        if (key.includes("question")) {
          countNumbers.push(JSON.parse(localStorage.getItem(key)));
        }
      }
      return countNumbers;
    },
    clear_localStoreg() {
      localStorage.clear();
    },
    createTimers() {
      let self = this;
      if (self.endStatus === "true") {
        this.axios.get(`${config.BASE_URL}/customers/createTimers`).then(function (response) {
          let res = response.data
          if (res.status === 'true') {
            self.timeoutHandle = res.data;
            var timer = self.timeoutHandle
            timer = timer.split(':');
            var minutes = timer[0];
            var seconds = timer[1];
            if (minutes == 0 && seconds == "00") {
              self.sendData(self.extracted())
              self.errors = self.text_error
            }
          }
        }).catch(function (errors) {

        });
      } // status
    },

  } //method
}
</script>
